/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import { Flex } from 'antd';
import { CONTEXT_MENU_CONSULT_SUMMARY } from 'Constants/consults';
import { bool, func, shape } from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { healthSummaryRetrieve } from 'Redux/modules/webChat/actions';
import { getHealthSummaryById } from 'Selectors/webChat/healthSummary';
import { Button } from 'semantic-ui-react';

import styles from './ConsultContent.less';
import FeeContent from './FeeContent/FeeContent';
import useConsultFee from './hooks/useConsultFee';
import { STEP_ONE, STEP_THREE, STEP_TWO } from './hooks/useStep';
import Review from './Review/Review';
import SummaryContent from './SummaryContent/SummaryContent';

const useDiscount = discount => {
  const [consultDiscount, setConsultDiscount] = useState(0);
  useMemo(() => {
    setConsultDiscount(discount || 0);
  }, [discount]);

  return { consultDiscount, setConsultDiscount };
};

const ConsultContent = props => {
  const {
    onClose,
    conversation,
    doctor,
    isFixed,
    finishConsult,
    loadingFinish,
    isErrorFinish,
    error,
    onBack,
    onNext,
    consult,
    step,
  } = props;

  const dispatch = useDispatch();
  const {
    latestConsult: { id: consultId },
  } = conversation;
  const { consultFee, getConsultFee } = useConsultFee(consultId);
  const { data } = consultFee;

  const {
    data: { enableAiChecker },
  } = useSelector(state => state.webChat.doctor);

  const contextMenu = useSelector(state => state.webChat.contextMenu);

  const { consultDiscount, setConsultDiscount } = useDiscount(data.consultDiscount);
  const [userDiscount, setUserDiscount] = useState(0);

  const fixedFee = data?.fixedFee;

  const [_, setClinic] = useState(null); // NOSONAR
  const onFinishConsult = () => {
    finishConsult({
      consultDiscount: userDiscount,
    });
  };

  useEffect(() => {
    getConsultFee();
  }, [getConsultFee]);

  const healthSummaryId = consult.healthSummary[0]?.healthSummaryId;

  const summary = useSelector(state => getHealthSummaryById(state, healthSummaryId));

  useEffect(() => {
    return () => {
      // trigger when close finish consult popup if open summary context menu need
      // to refetch health summary and update data
      if (healthSummaryId && contextMenu?.type.includes(CONTEXT_MENU_CONSULT_SUMMARY)) {
        dispatch(healthSummaryRetrieve({ doctorId: doctor.id, summaryId: healthSummaryId }));
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, doctor.id, healthSummaryId, contextMenu?.type]);

  const handleOnNext = () => {
    if (enableAiChecker) {
      onNext();
    } else {
      onFinishConsult();
    }
  };

  const contextButton = enableAiChecker ? 'Next' : 'Finish';
  return (
    <>
      {step === STEP_ONE && (
        <SummaryContent
          onNext={onNext}
          doctor={doctor}
          onClose={onClose}
          consult={consult}
          datePickerAppendToBody={false}
        />
      )}
      {step === STEP_TWO && (
        <FeeContent
          onNext={handleOnNext}
          onBack={onBack}
          consultFee={data}
          isFixed={isFixed}
          fixedFee={fixedFee}
          consultId={consultId}
          userDiscount={userDiscount}
          setUserDiscount={setUserDiscount}
          consultDiscount={consultDiscount}
          setConsultDiscount={setConsultDiscount}
          loadingFinish={loadingFinish}
          isErrorFinish={isErrorFinish}
          error={error}
          setClinic={setClinic}
          contextButton={contextButton}
        />
      )}
      {step === STEP_THREE && (
        <Flex vertical>
          <Review
            feeContent={
              <FeeContent
                onNext={onNext}
                onBack={onBack}
                consultFee={data}
                isFixed={isFixed}
                fixedFee={fixedFee}
                consultId={consultId}
                finishConsult={onFinishConsult}
                userDiscount={userDiscount}
                setUserDiscount={setUserDiscount}
                consultDiscount={consultDiscount}
                setConsultDiscount={setConsultDiscount}
                loadingFinish={loadingFinish}
                isErrorFinish={isErrorFinish}
                error={error}
                setClinic={setClinic}
                isViewMode
              />
            }
            summary={summary}
            doctor={doctor}
            consult={consult}
          />
          {consultFee.videoFee == null && (
            <div className={styles.actions}>
              <Button primary content="Finish" loading={loadingFinish} onClick={onFinishConsult} />
              <Button content="Back" onClick={onBack} />
              {isErrorFinish && (
                <span className="error" style={{ marginRight: 8, alignSelf: 'center' }}>
                  {error?.data?.message}
                </span>
              )}
            </div>
          )}
        </Flex>
      )}
    </>
  );
};

ConsultContent.propTypes = {
  onClose: func.isRequired,
  isFixed: bool.isRequired,
  doctor: shape({}).isRequired,
  finishConsult: func.isRequired,
  // consultFee: shape({}).isRequired,
  conversation: shape({}).isRequired,
  loadingFinish: bool.isRequired,
  isErrorFinish: bool.isRequired,
  error: shape({}),
};

ConsultContent.defaultProps = {
  error: null,
};

export default ConsultContent;
